// // Static blog data - actual API response
// export const STATIC_BLOG_DATA = {
//     "blogs": [
//         {
//             "id": "dummy_id",
//             "created_by": "Hrithik Hiranwar",
//             "key": "chaos-engineering.png",
//             "text": "Chaos Engineering",
//             "blog_url": "https://medium.com/@besocial_27455/chaos-engineering-bdc3581caf24",
//             "url": "https://s3.us-east-2.amazonaws.com/www.wingmanpartners.com/team-images/chaos-engineering.png",
//             "last_downloaded_at": "2025-12-22T23:00:09.295Z",
//             "createdAt": "2026-01-08T18:30:00.000Z",
//             "updatedAt": "2026-01-08T18:30:00.000Z"
//         },
//         {
//             "id": "fbe101b9-4c11-47f9-842e-ab39bd6452a4",
//             "created_by": "Daksh and Hrithik",
//             "key": "1755523108988-blog_cloud_cost.jpg",
//             "text": "Expert Guide to Cloud Cost Optimization for Reduced Expenses",
//             "blog_url": "https://medium.com/@besocial_27455/expert-guide-to-cloud-cost-optimization-for-reduced-expenses-8a964e09c7cb",
//             "url": "https://s3.us-east-2.amazonaws.com/www.wingmanpartners.com/team-images/1755523108988-blog_cloud_cost.jpg",
//             "last_downloaded_at": "2025-12-22T23:00:09.295Z",
//             "createdAt": "2024-06-03T18:30:00.000Z",
//             "updatedAt": "2025-12-22T23:00:09.295Z"
//         },
//         {
//             "id": "d386fc63-d9ee-4416-93db-d9ed4d1efeec",
//             "created_by": "Nishant Kaushik",
//             "key": "1755524316236-cxo_blog.png",
//             "text": "Leveraging Microservices in Cloud-Native Architecture",
//             "blog_url": "https://medium.com/@besocial_27455/leveraging-microservices-in-cloud-native-architecture-5bd0a77c5b28",
//             "url": "https://s3.us-east-2.amazonaws.com/www.wingmanpartners.com/team-images/1755524316236-cxo_blog.png",
//             "last_downloaded_at": "2025-12-22T23:00:09.312Z",
//             "createdAt": "2024-05-01T18:30:00.000Z",
//             "updatedAt": "2025-12-22T23:00:09.312Z"
//         },
//         {
//             "id": "78e27637-1270-407e-a0e4-1ed0c0a6d972",
//             "created_by": "Ankita Varshney",
//             "key": "1755524340684-ankita-gpt-blog.png",
//             "text": "The Use of ChatGPT for Quality Assurance",
//             "blog_url": "https://medium.com/@besocial_27455/the-use-of-chatgpt-for-quality-assurance-de65d59997e1",
//             "url": "https://s3.us-east-2.amazonaws.com/www.wingmanpartners.com/team-images/1755524340684-ankita-gpt-blog.png",
//             "last_downloaded_at": "2025-12-22T23:00:09.323Z",
//             "createdAt": "2024-03-03T18:30:00.000Z",
//             "updatedAt": "2025-12-22T23:00:09.324Z"
//         },
//         {
//             "id": "ebdcd7e3-7ac2-4995-9a44-901bb2cb8f6c",
//             "created_by": "Ankita Varshney",
//             "key": "1755524948879-ankita-blog.jpg",
//             "text": "Empower Manual Testing with Top Chrome Extensions",
//             "blog_url": "https://medium.com/@besocial_27455/empower-manual-testing-with-top-chrome-extensions-ba63b2d0c811",
//             "url": "https://s3.us-east-2.amazonaws.com/www.wingmanpartners.com/team-images/1755524948879-ankita-blog.jpg",
//             "last_downloaded_at": "2025-12-22T23:00:09.391Z",
//             "createdAt": "2023-11-20T18:30:00.000Z",
//             "updatedAt": "2025-12-22T23:00:09.391Z"
//         },
//         {
//             "id": "6c59563b-2e31-42c4-85cd-e007f628c6e1",
//             "created_by": "Anubhav Bhardwaj",
//             "key": "1755524452715-ux-2nd.jpg",
//             "text": "Top AI Platforms for UI/UX and its Transformative Power Part-2",
//             "blog_url": "https://medium.com/@besocial_27455/top-ai-platforms-for-ui-ux-and-its-transformative-power-part-2-9829afa514af",
//             "url": "https://s3.us-east-2.amazonaws.com/www.wingmanpartners.com/team-images/1755524452715-ux-2nd.jpg",
//             "last_downloaded_at": "2025-12-22T23:00:09.404Z",
//             "createdAt": "2023-10-26T18:30:00.000Z",
//             "updatedAt": "2025-12-22T23:00:09.404Z"
//         },
//         {
//             "id": "4d8c9c37-44cf-4dd1-b60e-0412cc2f6f9f",
//             "created_by": "Anubhav Bhardwaj",
//             "key": "1755524431585-ux-1st.jpg",
//             "text": "Top AI Platforms for UI/UX and its Transformative Power",
//             "blog_url": "https://medium.com/@besocial_27455/top-ai-platforms-for-ui-ux-and-its-transformative-power-ff2b27b5d5c9",
//             "url": "https://s3.us-east-2.amazonaws.com/www.wingmanpartners.com/team-images/1755524431585-ux-1st.jpg",
//             "last_downloaded_at": "2025-12-22T23:00:09.415Z",
//             "createdAt": "2023-10-19T18:30:00.000Z",
//             "updatedAt": "2025-12-22T23:00:09.415Z"
//         },
//         {
//             "id": "3b8dd337-dc93-4c4b-a11c-4e99faa0cedb",
//             "created_by": "Unique Sharma",
//             "key": "1755524801882-blog-card-img-1.svg",
//             "text": "Optimizing Storage Costs in Amazon S3 and EBS While Ensuring Data Availability and Performance",
//             "blog_url": "https://medium.com/@besocial_27455/optimizing-storage-costs-in-amazon-s3-and-ebs-while-ensuring-data-availability-and-performance-655ee83e5e11",
//             "url": "https://s3.us-east-2.amazonaws.com/www.wingmanpartners.com/team-images/1755524801882-blog-card-img-1.svg",
//             "last_downloaded_at": "2025-12-22T23:00:09.482Z",
//             "createdAt": "2023-10-15T18:30:00.000Z",
//             "updatedAt": "2025-12-22T23:00:09.482Z"
//         },
//         {
//             "id": "51dbd0f7-bbf1-4f33-bf2d-4fee36ebcf5c",
//             "created_by": "Mukul Srivastava",
//             "key": "1755524762590-blog-card-img-2.jpg",
//             "text": "Ensuring Effortless Project Execution with DevOps Expertise at Wingman Partners",
//             "blog_url": "https://medium.com/@besocial_27455/ensuring-effortless-project-execution-with-devops-expertise-at-wingman-partners-aa2f8d1d59f5",
//             "url": "https://s3.us-east-2.amazonaws.com/www.wingmanpartners.com/team-images/1755524762590-blog-card-img-2.jpg",
//             "last_downloaded_at": "2025-12-22T23:00:09.494Z",
//             "createdAt": "2023-09-24T18:30:00.000Z",
//             "updatedAt": "2025-12-22T23:00:09.494Z"
//         },
//         {
//             "id": "7bd47f58-50b6-4d29-a7b1-dd9d9d29a989",
//             "created_by": "Kanish Tyagi",
//             "key": "1755524891954-blog-card-img-3.svg",
//             "text": "Common Quality Assurance Mistakes and How to Avoid Them: A Complete Guide",
//             "blog_url": "https://medium.com/@besocial_27455/common-quality-assurance-mistakes-and-how-to-avoid-them-a-complete-guide-bd528b5f66b6",
//             "url": "https://s3.us-east-2.amazonaws.com/www.wingmanpartners.com/team-images/1755524891954-blog-card-img-3.svg",
//             "last_downloaded_at": "2025-12-22T23:00:09.507Z",
//             "createdAt": "2023-09-14T18:30:00.000Z",
//             "updatedAt": "2025-12-22T23:00:09.507Z"
//         },
//         {
//             "id": "f22351cc-dc52-4c54-9b0c-a4eb8e0318fb",
//             "created_by": "Jayant Singh",
//             "key": "1755524829889-jayant-blog-img.svg",
//             "text": "Deceptive Patterns: The Dark Approach to UI Design",
//             "blog_url": "https://medium.com/@besocial_27455/deceptive-patterns-the-dark-approach-to-ui-design-c26e22036cce",
//             "url": "https://s3.us-east-2.amazonaws.com/www.wingmanpartners.com/team-images/1755524829889-jayant-blog-img.svg",
//             "last_downloaded_at": "2025-12-22T23:00:09.582Z",
//             "createdAt": "2023-09-05T18:30:00.000Z",
//             "updatedAt": "2025-12-22T23:00:09.582Z"
//         },
//         {
//             "id": "08059558-0f7f-4eee-8f16-b7cad967c7e6",
//             "created_by": "Nishant Kaushik",
//             "key": "1755524854904-blog-card-img-5.svg",
//             "text": "EDGE COMPUTING",
//             "blog_url": "https://medium.com/@besocial_27455/edge-computing-fcc5f938bb3b",
//             "url": "https://s3.us-east-2.amazonaws.com/www.wingmanpartners.com/team-images/1755524854904-blog-card-img-5.svg",
//             "last_downloaded_at": "2025-12-22T23:00:09.593Z",
//             "createdAt": "2023-08-31T18:30:00.000Z",
//             "updatedAt": "2025-12-22T23:00:09.594Z"
//         },
//         {
//             "id": "f8044b35-85cc-4b5c-8aa5-bdf3210c2ca9",
//             "created_by": "Nishant Kaushik",
//             "key": "1755524726368-blog-card-img-6.jpg",
//             "text": "Optimize your Report Project Performance with HTMX’s Lazy Loading",
//             "blog_url": "https://medium.com/@besocial_27455/optimizing-report-project-performance-with-htmxs-lazy-loading-bc182684d250",
//             "url": "https://s3.us-east-2.amazonaws.com/www.wingmanpartners.com/team-images/1755524726368-blog-card-img-6.jpg",
//             "last_downloaded_at": "2025-12-22T23:00:09.605Z",
//             "createdAt": "2023-07-24T18:30:00.000Z",
//             "updatedAt": "2025-12-22T23:00:09.605Z"
//         },
//         {
//             "id": "95494251-28f2-4e6f-a2e6-5539258ff348",
//             "created_by": "Vikas Raghav",
//             "key": "1755525051314-vikas-blog-img.svg",
//             "text": "How To: Publish a docker image to the container registry on approval using a GitHub Action",
//             "blog_url": "https://medium.com/@besocial_27455/how-to-publish-a-docker-image-to-the-container-registry-on-approval-using-a-github-action-6d2346a4049a",
//             "url": "https://s3.us-east-2.amazonaws.com/www.wingmanpartners.com/team-images/1755525051314-vikas-blog-img.svg",
//             "last_downloaded_at": "2025-12-22T23:00:09.617Z",
//             "createdAt": "2023-03-15T18:30:00.000Z",
//             "updatedAt": "2025-12-22T23:00:09.617Z"
//         },
//         {
//             "id": "39909c52-f57a-42bc-b62e-65057e085af2",
//             "created_by": "Samyakt Jain",
//             "key": "1755524696273-samyakt-blog-img.svg",
//             "text": "Health Insurance Portability and Accountability Act (HIPAA)",
//             "blog_url": "https://medium.com/@besocial_27455/health-insurance-portability-and-accountability-act-hipaa-wingman-partners-e3e0674a2c2",
//             "url": "https://s3.us-east-2.amazonaws.com/www.wingmanpartners.com/team-images/1755524696273-samyakt-blog-img.svg",
//             "last_downloaded_at": "2025-12-22T23:00:09.689Z",
//             "createdAt": "2022-07-06T18:30:00.000Z",
//             "updatedAt": "2025-12-22T23:00:09.689Z"
//         },
//         {
//             "id": "d9ca906e-11dc-4a30-93c2-d02578896adc",
//             "created_by": "Unique Sharma",
//             "key": "1755524568655-unique-blog-img.svg",
//             "text": "Azure DevOps",
//             "blog_url": "https://medium.com/@unique_sharma/azure-devops-1899a03d0f4b",
//             "url": "https://s3.us-east-2.amazonaws.com/www.wingmanpartners.com/team-images/1755524568655-unique-blog-img.svg",
//             "last_downloaded_at": "2025-12-22T23:00:09.701Z",
//             "createdAt": "2022-04-24T18:30:00.000Z",
//             "updatedAt": "2025-12-22T23:00:09.701Z"
//         },
//         {
//             "id": "9f9afe99-7aa8-4178-98e0-db6fb4cd07e1",
//             "created_by": "Mohit Thakur, Mohit Yadav, Kriti Shukla",
//             "key": "1755525025290-mohit-blog-img.svg",
//             "text": "Simplicity Understanding of Javascript DOM",
//             "blog_url": "https://medium.com/@mt000569/simplicity-understanding-of-javascript-dom-86e05744e97a",
//             "url": "https://s3.us-east-2.amazonaws.com/www.wingmanpartners.com/team-images/1755525025290-mohit-blog-img.svg",
//             "last_downloaded_at": "2025-12-22T23:00:09.712Z",
//             "createdAt": "2022-03-05T18:30:00.000Z",
//             "updatedAt": "2025-12-22T23:00:09.712Z"
//         },
//         {
//             "id": "0686210a-9fe9-456b-8dbf-d3a37d8a4479",
//             "created_by": "Harpreet Singh Arora",
//             "key": "1755524548847-harpareet-blog-img.svg",
//             "text": "2FA Bypass Securing methods",
//             "blog_url": "https://honeyarora11-hs.medium.com/2fa-bypass-securing-methods-7cb28a70c7e1",
//             "url": "https://s3.us-east-2.amazonaws.com/www.wingmanpartners.com/team-images/1755524548847-harpareet-blog-img.svg",
//             "last_downloaded_at": "2025-12-22T23:00:09.787Z",
//             "createdAt": "2021-06-27T18:30:00.000Z",
//             "updatedAt": "2025-12-22T23:00:09.788Z"
//         },
//         {
//             "id": "e409344a-a229-4b63-ab53-2c4b663d475b",
//             "created_by": "Kawaldeep Singh",
//             "key": "1755525097952-image (1).png",
//             "text": "Health Insurance Portability and Accountability Act (HIPAA)",
//             "blog_url": "https://medium.com/@besocial_27455/health-insurance-portability-and-accountability-act-hipaa-wingman-partners-e3e0674a2c2",
//             "url": "https://s3.us-east-2.amazonaws.com/www.wingmanpartners.com/team-images/1755525097952-image (1).png",
//             "last_downloaded_at": "2025-12-22T23:00:09.799Z",
//             "createdAt": "2021-05-22T18:30:00.000Z",
//             "updatedAt": "2025-12-22T23:00:09.799Z"
//         },
//         {
//             "id": "3b910d04-72e1-4ef3-97a8-567a495f7dd4",
//             "created_by": "Kekashri Joshi",
//             "key": "1755524625784-kekashri-blog-img.svg",
//             "text": "AWS Chatbot For Sending Notifications On Slack Regarding CodePipelines Status",
//             "blog_url": "https://joshikekashri.medium.com/aws-chatbot-for-sending-notifications-on-slack-regarding-codepipelines-status-18340be837c",
//             "url": "https://s3.us-east-2.amazonaws.com/www.wingmanpartners.com/team-images/1755524625784-kekashri-blog-img.svg",
//             "last_downloaded_at": "2025-12-22T23:00:09.812Z",
//             "createdAt": "2021-05-20T18:30:00.000Z",
//             "updatedAt": "2025-12-22T23:00:09.812Z"
//         },
//         {
//             "id": "11dd64f6-8cac-4396-97c6-c316d90d5d22",
//             "created_by": "Mukul Srivastava",
//             "key": "1755524606554-mukul-blog-img.jpg",
//             "text": "Setting Up Cypress Test Case On AWS ECS Containers.",
//             "blog_url": "https://mukul-sri.medium.com/setting-up-cypress-test-case-on-aws-ecs-containers-2dbf3d31b16e",
//             "url": "https://s3.us-east-2.amazonaws.com/www.wingmanpartners.com/team-images/1755524606554-mukul-blog-img.jpg",
//             "last_downloaded_at": "2025-12-22T23:00:09.822Z",
//             "createdAt": "2021-03-16T18:30:00.000Z",
//             "updatedAt": "2025-12-22T23:00:09.822Z"
//         }
//     ],
//     "pagination": {
//         "page": 1,
//         "limit": 300,
//         "total": 20,
//         "totalPages": 1
//     }
// };

// Static team data - actual API response
// "rank" is used to define the designation sequence (e.g., SDE III = 1, SDE II = 2).
// "ui_ranking" is used to define the display order within the same designation
// (e.g., if two people have the SDE III designation, ui_ranking decides who appears first).

export const STATIC_TEAM_DATA = {
    "users": {
        "Management": [
            {
                "id": "0d238746-ddd5-4e8f-b8de-ca45d3dac60b",
                "first_name": "Ashav",
                "last_name": "Kaushik",
                "url": "https://s3.us-east-2.amazonaws.com/www.wingmanpartners.com/team-images/1755502528375-ashav-kaushik.jpg",
                "key": "1755502528375-ashav-kaushik.jpg",
                "last_downloaded_at": "2025-12-23T07:20:25.925Z",
                "status": "ACTIVE",
                "ui_ranking": 1,
                "designation": "CEO",
                "rank": 1
            },
            {
                "id": "2b0efdcf-5db5-4389-8790-21c4fa42a372",
                "first_name": "Nishant",
                "last_name": "Kaushik",
                "url": "https://s3.us-east-2.amazonaws.com/www.wingmanpartners.com/team-images/1755502572797-nishant-kaushik.jpg",
                "key": "1755502572797-nishant-kaushik.jpg",
                "last_downloaded_at": "2025-12-23T07:20:25.937Z",
                "status": "ACTIVE",
                "ui_ranking": 1,
                "designation": "VP Engineering",
                "rank": 2
            },
            {
                "id": "e99d38fb-6716-4fd6-a5ff-da9599076cad",
                "first_name": "Kawaldeep",
                "last_name": "Singh",
                "url": "https://s3.us-east-2.amazonaws.com/www.wingmanpartners.com/team-images/1755589590639-kawaldeep-singh.jpg",
                "key": "1755589590639-kawaldeep-singh.jpg",
                "last_downloaded_at": "2025-12-23T07:20:26.101Z",
                "status": "ACTIVE",
                "ui_ranking": 1,
                "designation": "Tech Architect",
                "rank": 3
            },
            {
                "id": "af526fd3-38d0-4c23-80e1-fa94cceb69ef",
                "first_name": "Mukul",
                "last_name": "Srivastava",
                "url": "https://s3.us-east-2.amazonaws.com/www.wingmanpartners.com/team-images/1755589559227-mukul-srivastava.jpg",
                "key": "1755589559227-mukul-srivastava.jpg",
                "last_downloaded_at": "2025-12-23T07:20:26.089Z",
                "status": "ACTIVE",
                "ui_ranking": 2,
                "designation": "DevOps Manager",
                "rank": 4
            }
        ],
        "Senior Leadership": [
            {
                "id": "ed91bfc4-73cc-471c-9362-ee0b6b63970c",
                "first_name": "Mohit",
                "last_name": "Yadav",
                "url": "https://s3.us-east-2.amazonaws.com/www.wingmanpartners.com/team-images/mohit.jpg",
                "key": "1755589692630-mohit-yadav.jpg",
                "last_downloaded_at": "2025-12-23T07:20:26.195Z",
                "status": "ACTIVE",
                "ui_ranking": 1,
                "designation": "Lead Engineer",
                "rank": 1
            },
            {
                "id": "4212c85b-9504-497d-8e56-404a0a96b937",
                "first_name": "Aman",
                "last_name": "Sharma",
                "url": "https://s3.us-east-2.amazonaws.com/www.wingmanpartners.com/team-images/1755589730098-aman-sharma.jpg",
                "key": "1755589730098-aman-sharma.jpg",
                "last_downloaded_at": "2025-12-23T07:20:26.205Z",
                "status": "ACTIVE",
                "ui_ranking": 2,
                "designation": "Lead Engineer",
                "rank": 1
            },
            {
                "id": "75d795cc-2a25-422c-8842-4ba632d7c7fc",
                "first_name": "Sandeep",
                "last_name": "Jalal",
                "url": "https://s3.us-east-2.amazonaws.com/www.wingmanpartners.com/team-images/1755589953856-sandeep-jalal.jpg",
                "key": "1755589953856-sandeep-jalal.jpg",
                "last_downloaded_at": "2025-12-23T07:20:26.216Z",
                "status": "ACTIVE",
                "ui_ranking": 3,
                "designation": "Lead Engineer",
                "rank": 1
            }
        ],
        "Development": [
            {
                "id": "753e2083-d7bd-4fb9-96d1-0d4a6636da93",
                "first_name": "Aakash",
                "last_name": "Tyagi",
                "url": "https://s3.us-east-2.amazonaws.com/www.wingmanpartners.com/team-images/1755591065667-akash-tyagi.jpg",
                "key": "1755591065667-akash-tyagi.jpg",
                "last_downloaded_at": "2025-12-23T07:20:26.310Z",
                "status": "ACTIVE",
                "ui_ranking": 1,
                "designation": "SDE III",
                "rank": 1
            },
            {
                "id": "0eb5b0c7-2ae7-47e8-a430-cfcad717b2b1",
                "first_name": "Nadeem",
                "last_name": "Khan",
                "url": "https://s3.us-east-2.amazonaws.com/www.wingmanpartners.com/team-images/1755591105800-nadeem-khan.jpg",
                "key": "1755591105800-nadeem-khan.jpg",
                "last_downloaded_at": "2025-12-23T07:20:26.321Z",
                "status": "ACTIVE",
                "ui_ranking": 2,
                "designation": "SDE III",
                "rank": 1
            },
            {
                "id": "644936b5-a48c-4e7b-a82e-7bfb21ec355c",
                "first_name": "Divesh Kumar",
                "last_name": "Singh",
                "url": "https://s3.us-east-2.amazonaws.com/www.wingmanpartners.com/team-images/1755591199202-divesh-kumar-singh.jpg",
                "key": "1755591199202-divesh-kumar-singh.jpg",
                "last_downloaded_at": "2025-12-23T07:20:26.405Z",
                "status": "ACTIVE",
                "ui_ranking": 3,
                "designation": "SDE III",
                "rank": 1
            },
            {
                "id": "192ffe0a-d879-4f2c-a7e0-bb46999b00bc",
                "first_name": "Ajay",
                "last_name": "Rathour",
                "url": "https://s3.us-east-2.amazonaws.com/www.wingmanpartners.com/team-images/1755591266639-ajay-rathod.jpg",
                "key": "1755591266639-ajay-rathod.jpg",
                "last_downloaded_at": "2025-12-23T07:20:26.488Z",
                "status": "ACTIVE",
                "ui_ranking": 4,
                "designation": "SDE III",
                "rank": 1
            },
            {
                "id": "4c0cda4b-1802-4f7f-9cde-82282b1f074d",
                "first_name": "Yash",
                "last_name": "Chaurasiya",
                "url": "https://s3.us-east-2.amazonaws.com/www.wingmanpartners.com/team-images/1755591491763-yash-chaurasiya.jpg",
                "key": "1755591491763-yash-chaurasiya.jpg",
                "last_downloaded_at": "2025-12-23T07:20:26.498Z",
                "status": "ACTIVE",
                "ui_ranking": 1,
                "designation": "SDE II",
                "rank": 2
            },
            {
                "id": "cc86f85a-733c-4cfc-9cf7-dafc4238a425",
                "first_name": "Shivank",
                "last_name": "Chauhan",
                "url": "https://s3.us-east-2.amazonaws.com/www.wingmanpartners.com/team-images/1755591588993-shivank-chauhan.jpg",
                "key": "1755591588993-shivank-chauhan.jpg",
                "last_downloaded_at": "2025-12-23T07:20:26.508Z",
                "status": "ACTIVE",
                "ui_ranking": 2,
                "designation": "SDE II",
                "rank": 2
            },
            {
                "id": "72db2e66-0aae-4acc-b00d-a498f9ad7484",
                "first_name": "Gaurav",
                "last_name": "Rajpoot",
                "url": "https://s3.us-east-2.amazonaws.com/www.wingmanpartners.com/team-images/1755591626908-gaurav-rajpoot.jpg",
                "key": "1755591626908-gaurav-rajpoot.jpg",
                "last_downloaded_at": "2025-12-23T07:20:26.518Z",
                "status": "ACTIVE",
                "ui_ranking": 3,
                "designation": "SDE II",
                "rank": 2
            },
            {
                "id": "f16f8841-ecf5-4584-8337-3b047c24c003",
                "first_name": "Divyanshu",
                "last_name": "Kishan",
                "url": "https://s3.us-east-2.amazonaws.com/www.wingmanpartners.com/team-images/1755591704876-divyanshu-kishan.jpg",
                "key": "1755591704876-divyanshu-kishan.jpg",
                "last_downloaded_at": "2025-12-23T07:20:26.529Z",
                "status": "ACTIVE",
                "ui_ranking": 4,
                "designation": "SDE II",
                "rank": 2
            },
            {
                "id": "237230e0-2667-475c-8c43-d7f30e94eb3a",
                "first_name": "Suyash Vikram",
                "last_name": "Singh",
                "url": "https://s3.us-east-2.amazonaws.com/www.wingmanpartners.com/team-images/suyash.png",
                "key": "1755591764282-suyash.jpg",
                "last_downloaded_at": "2025-12-23T07:20:26.587Z",
                "status": "ACTIVE",
                "ui_ranking": 5,
                "designation": "SDE II",
                "rank": 2
            },
            {
                "id": "6184fcc6-2e8d-4755-8e3b-da186cf7459b",
                "first_name": "Muskan",
                "last_name": "Kumari",
                "url": "https://s3.us-east-2.amazonaws.com/www.wingmanpartners.com/team-images/1755592468983-muskan-kumari.jpg",
                "key": "1755592468983-muskan-kumari.jpg",
                "last_downloaded_at": "2025-12-23T07:20:26.601Z",
                "status": "ACTIVE",
                "ui_ranking": 1,
                "designation": "SDE I",
                "rank": 3
            },
            {
                "id": "f75fadcf-2843-4376-86b3-c3c82bb34921",
                "first_name": "Lokendra",
                "last_name": "Singh",
                "url": "https://s3.us-east-2.amazonaws.com/www.wingmanpartners.com/team-images/1755592500302-lokendra-singh.jpg",
                "key": "1755592500302-lokendra-singh.jpg",
                "last_downloaded_at": "2025-12-23T07:20:26.612Z",
                "status": "ACTIVE",
                "ui_ranking": 2,
                "designation": "SDE I",
                "rank": 3
            },
            {
                "id": "ca141966-b935-4939-ab65-de5ebf20a797",
                "first_name": "Ankit",
                "last_name": "Kumar",
                "url": "https://s3.us-east-2.amazonaws.com/www.wingmanpartners.com/team-images/1755592531744-ankit-kumar.jpg",
                "key": "1755592531744-ankit-kumar.jpg",
                "last_downloaded_at": "2025-12-23T07:20:26.622Z",
                "status": "ACTIVE",
                "ui_ranking": 3,
                "designation": "SDE I",
                "rank": 3
            },
            {
                "id": "b9b29917-4ec4-47d4-b1ac-ae5382eb9782",
                "first_name": "Rahul",
                "last_name": "Sahani",
                "url": "https://s3.us-east-2.amazonaws.com/www.wingmanpartners.com/team-images/1758010108208-Rahul.jpg",
                "key": "1758010108208-Rahul.jpg",
                "last_downloaded_at": "2025-12-23T07:20:26.697Z",
                "status": "ACTIVE",
                "ui_ranking": 4,
                "designation": "SDE I",
                "rank": 3
            },
            {
                "id": "0af7fd89-341a-4f7b-aeb8-8b8c866d6698",
                "first_name": "Aanchal",
                "last_name": "Saxena",
                "url": "https://s3.us-east-2.amazonaws.com/www.wingmanpartners.com/team-images/1758010116689-Aanchal.jpg",
                "key": "1758010116689-Aanchal.jpg",
                "last_downloaded_at": "2025-12-23T07:20:26.707Z",
                "status": "ACTIVE",
                "ui_ranking": 5,
                "designation": "SDE I",
                "rank": 3
            },
            {
                "id": "dummy_id_1",
                "first_name": "Kartik",
                "last_name": "Malik",
                "url": "https://s3.us-east-2.amazonaws.com/www.wingmanpartners.com/team-images/kartik.jpg",
                "key": "kartik.jpg",
                "last_downloaded_at": "2025-12-23T07:20:26.707Z",
                "status": "ACTIVE",
                "ui_ranking": 6,
                "designation": "SDE I",
                "rank": 3
            },
            {
                "id": "dummy_id_2",
                "first_name": "Vivek",
                "last_name": "Kumar",
                "url": "https://s3.us-east-2.amazonaws.com/www.wingmanpartners.com/team-images/vivek.jpg",
                "key": "vivek.jpg",
                "last_downloaded_at": "2025-12-23T07:20:26.707Z",
                "status": "ACTIVE",
                "ui_ranking": 7,
                "designation": "SDE I",
                "rank": 3
            }
        ],
        "Design": [
            {
                "id": "006c7f88-7902-424e-88c1-b96339c93e83",
                "first_name": "Anubhav",
                "last_name": "Bhardwaj",
                "url": "https://s3.us-east-2.amazonaws.com/www.wingmanpartners.com/team-images/anubhav.png",
                "key": "1755592436456-anubhav-bhardwaj.jpg",
                "last_downloaded_at": "2025-12-23T07:20:26.723Z",
                "status": "ACTIVE",
                "ui_ranking": 1,
                "designation": "UI/UX Designer",
                "rank": 1
            },
            {
                "id": "dummy_id_3",
                "first_name": "Divyanshi",
                "last_name": "",
                "url": "https://s3.us-east-2.amazonaws.com/www.wingmanpartners.com/team-images/divyanshi-jaiswal.png",
                "key": "divyanshi-jaiswal.png",
                "last_downloaded_at": "2025-12-23T07:20:26.723Z",
                "status": "ACTIVE",
                "ui_ranking": 2,
                "designation": "UI/UX Designer",
                "rank": 1
            },
            {
                "id": "d582526a-387c-4f18-88a2-b78b4ba454ff",
                "first_name": "Khushi",
                "last_name": "Gaur",
                "url": "https://s3.us-east-2.amazonaws.com/www.wingmanpartners.com/team-images/1758010081865-Khushi Gaur.jpg",
                "key": "1758010081865-Khushi Gaur.jpg",
                "last_downloaded_at": "2025-12-23T07:20:26.734Z",
                "status": "ACTIVE",
                "ui_ranking": 1,
                "designation": "Junior UI/UX Designer",
                "rank": 2
            }
        ],
        "Quality Assurance": [
            {
                "id": "8c654db5-39a4-4314-a987-eb44b55be8a8",
                "first_name": "Shivani",
                "last_name": "Tiwari",
                "url": "https://s3.us-east-2.amazonaws.com/www.wingmanpartners.com/team-images/1755591321919-shivani-tiwari.jpg",
                "key": "1755591321919-shivani-tiwari.jpg",
                "last_downloaded_at": "2025-12-23T07:20:26.793Z",
                "status": "ACTIVE",
                "ui_ranking": 1,
                "designation": "QA III",
                "rank": 1
            },
            {
                "id": "3893f27d-25d3-44c1-be62-28c44af21618",
                "first_name": "Nishita",
                "last_name": "Chaudhary",
                "url": "https://s3.us-east-2.amazonaws.com/www.wingmanpartners.com/team-images/1755591888720-nishita-chaudhary.jpg",
                "key": "1755591888720-nishita-chaudhary.jpg",
                "last_downloaded_at": "2025-12-23T07:20:26.883Z",
                "status": "ACTIVE",
                "ui_ranking": 1,
                "designation": "QA II",
                "rank": 2
            },
            {
                "id": "2b92c70f-b666-494d-ae7a-82b1348079ad",
                "first_name": "Hemanshi",
                "last_name": "Choudhary",
                "url": "https://s3.us-east-2.amazonaws.com/www.wingmanpartners.com/team-images/hemanshi.png",
                "key": "1755592901016-hemanshi.jpg",
                "last_downloaded_at": "2025-12-23T07:20:26.896Z",
                "status": "ACTIVE",
                "ui_ranking": 1,
                "designation": "QA I",
                "rank": 3
            },
            {
                "id": "dummy_id_4",
                "first_name": "Vrienda",
                "last_name": "Pathak",
                "url": "https://s3.us-east-2.amazonaws.com/www.wingmanpartners.com/team-images/vrienda-pathak.jpg",
                "key": "vrienda-pathak.jpg",
                "last_downloaded_at": "2025-12-23T07:20:26.896Z",
                "status": "ACTIVE",
                "ui_ranking": 2,
                "designation": "QA I",
                "rank": 3
            },
            {
                "id": "dummy_id_5",
                "first_name": "Stuti",
                "last_name": "",
                "url": "https://s3.us-east-2.amazonaws.com/www.wingmanpartners.com/team-images/stuti-srivastava.webp",
                "key": "stuti-srivastava.webp",
                "last_downloaded_at": "2025-12-23T07:20:26.896Z",
                "status": "ACTIVE",
                "ui_ranking": 2,
                "designation": "QA I",
                "rank": 3
            }
        ],
        "DevOps": [
            {
                "id": "e5439396-8d31-40f9-9f06-f3c6858a17d0",
                "first_name": "Vikas",
                "last_name": "Raghav",
                "url": "https://s3.us-east-2.amazonaws.com/www.wingmanpartners.com/team-images/1755591357994-vikas-raghav.jpg",
                "key": "1755591357994-vikas-raghav.jpg",
                "last_downloaded_at": "2025-12-23T07:20:26.920Z",
                "status": "ACTIVE",
                "ui_ranking": 1,
                "designation": "DevOps III",
                "rank": 1
            },
            {
                "id": "ee80a982-e612-4068-97a1-85ed4401cfa7",
                "first_name": "Akash",
                "last_name": "Srivastava",
                "url": "https://s3.us-east-2.amazonaws.com/www.wingmanpartners.com/team-images/1755592159752-aakash-srivastava.jpg",
                "key": "1755592159752-aakash-srivastava.jpg",
                "last_downloaded_at": "2025-12-23T07:20:27.003Z",
                "status": "ACTIVE",
                "ui_ranking": 1,
                "designation": "DevOps II",
                "rank": 2
            },

            {
                "id": "dummy_id_aastha",
                "first_name": "Astha Sharma",
                "last_name": "",
                "url": "https://s3.us-east-2.amazonaws.com/www.wingmanpartners.com/team-images/aastha.png",
                "key": "aastha.png",
                "last_downloaded_at": "2025-12-23T07:20:27.108Z",
                "status": "ACTIVE",
                "ui_ranking": 1,
                "designation": "DevOps I",
                "rank": 3
            },
            {
                "id": "fda4deb8-14ff-43bb-895e-9ee474886d34",
                "first_name": "Maulik",
                "last_name": "Pandey",
                "url": "https://s3.us-east-2.amazonaws.com/www.wingmanpartners.com/team-images/1758012164627-IMG_2034.jpg",
                "key": "1758012164627-IMG_2034.jpg",
                "last_downloaded_at": "2025-12-23T07:20:27.108Z",
                "status": "ACTIVE",
                "ui_ranking": 2,
                "designation": "DevOps I",
                "rank": 3
            },
            {
                "id": "dummy_id_6",
                "first_name": "Ayush",
                "last_name": "Rawat",
                "url": "https://s3.us-east-2.amazonaws.com/www.wingmanpartners.com/team-images/ayush-rawat.jpg",
                "key": "ayush-rawat.jpg",
                "last_downloaded_at": "2025-12-23T07:20:27.108Z",
                "status": "ACTIVE",
                "ui_ranking": 3,
                "designation": "DevOps I",
                "rank": 3
            }
        ],
        "Project Management": [
            {
                "id": "4c5fe302-702c-4011-b61f-75241d4380db",
                "first_name": "Ananya",
                "last_name": "Singh",
                "url": "https://s3.us-east-2.amazonaws.com/www.wingmanpartners.com/team-images/ananya.jpeg",
                "key": "1755592212848-ananya-singh.jpg",
                "last_downloaded_at": "2025-12-23T07:20:27.121Z",
                "status": "ACTIVE",
                "ui_ranking": 1,
                "designation": "Project Co-ordinator",
                "rank": 1
            },
            {
                "id": "ba280bc9-c148-4be2-ba88-88ad43085fb7",
                "first_name": "Yana",
                "last_name": "Rakesh",
                "url": "https://s3.us-east-2.amazonaws.com/www.wingmanpartners.com/team-images/yana.png",
                "key": "1755593264209-yana.jpg",
                "last_downloaded_at": "2025-12-23T07:20:27.188Z",
                "status": "ACTIVE",
                "ui_ranking": 1,
                "designation": "Associate Project Co-ordinator",
                "rank": 2
            },
            {
                "id": "b12188f9-3216-49e3-adc9-739a8e32b173",
                "first_name": "Arya",
                "last_name": "Sharma",
                "url": "https://s3.us-east-2.amazonaws.com/www.wingmanpartners.com/team-images/1755593299580-arya-sharma.jpg",
                "key": "1755593299580-arya-sharma.jpg",
                "last_downloaded_at": "2025-12-23T07:20:27.198Z",
                "status": "ACTIVE",
                "ui_ranking": 2,
                "designation": "Associate Project Co-ordinator",
                "rank": 2
            },
            {
                "id": "61198813-1cd6-4d4c-bb38-b9ce88abd7d4",
                "first_name": "Bhumika",
                "last_name": "Kaushik",
                "url": "https://s3.us-east-2.amazonaws.com/www.wingmanpartners.com/team-images/bhumika.jpg",
                "key": "1758010066232-Bhumika.jpg",
                "last_downloaded_at": "2025-12-23T07:20:27.208Z",
                "status": "ACTIVE",
                "ui_ranking": 3,
                "designation": "Associate Project Co-ordinator",
                "rank": 2
            }
        ],
        "Human Resource": [
            {
                "id": "7ac41f10-436f-4bc9-85af-1d2694a0d37f",
                "first_name": "Pramita",
                "last_name": "Ghosh",
                "url": "https://s3.us-east-2.amazonaws.com/www.wingmanpartners.com/team-images/1755591392579-pramita-ghosh.jpg",
                "key": "1755591392579-pramita-ghosh.jpg",
                "last_downloaded_at": "2025-12-23T07:20:27.290Z",
                "status": "ACTIVE",
                "ui_ranking": 1,
                "designation": "HR Finance",
                "rank": 1
            }
        ],
        "Business Development": [
            {
                "id": "7c39a3a0-d516-45ff-ba63-b94e75ef4dd8",
                "first_name": "Daksh",
                "last_name": "Kotian",
                "url": "https://s3.us-east-2.amazonaws.com/www.wingmanpartners.com/team-images/1755593047536-daksh.jpg",
                "key": "1755593047536-daksh.jpg",
                "last_downloaded_at": "2025-12-23T07:20:27.083Z",
                "status": "ACTIVE",
                "ui_ranking": 1,
                "designation": "BDE",
                "rank": 1
            },
            {
                "id": "4fefbb74-df74-44d3-931d-014fa38aa7a4",
                "first_name": "Meesha",
                "last_name": "Khanna",
                "url": "https://s3.us-east-2.amazonaws.com/www.wingmanpartners.com/team-images/1755593421770-meesha.png",
                "key": "1755593421770-meesha.png",
                "last_downloaded_at": "2025-12-23T07:20:27.386Z",
                "status": "ACTIVE",
                "ui_ranking": 2,
                "designation": "BDE",
                "rank": 1
            },
            {
                "id": "dummy_id_8",
                "first_name": "Gun",
                "last_name": "Gupta",
                "url": "https://s3.us-east-2.amazonaws.com/www.wingmanpartners.com/team-images/gun.jpeg",
                "key": "gun-gupta.jpg",
                "last_downloaded_at": "2025-12-23T07:20:27.386Z",
                "status": "ACTIVE",
                "ui_ranking": 3,
                "designation": "BDE",
                "rank": 1
            }
        ]
    },
    "pagination": {
        "page": 1,
        "limit": 500,
        "total": 47,
        "totalPages": 1
    }
};